export default function useTinymce() {
  function convertToGermanQuotationMarks(editor) {
    return editor.on("keydown", (e) => {
      if (e.key === '"') {
        e.preventDefault();
        const content = editor.getContent({ format: "text" });
        const selection = editor.selection;
        const cursorPosition = selection.getRng().startOffset;
        const lastCharacter = content.charAt(cursorPosition - 1);

        if (cursorPosition > 0) {
          if (/\s| /.test(lastCharacter)) {
            editor.insertContent("„");
          } else {
            editor.insertContent("“");
          }
        } else {
          editor.insertContent("„");
        }
      }
    });
  }

  return { convertToGermanQuotationMarks };
}
